<template>
    <div class="text-center text-white text-lg uppercase mt-6 mb-8">{{ lbl.sidemenu.service_info }}</div>
    <div class="px-11">
        <div class="flex items-start">
            <div class="flex-none">
                <div class="avatar">
                    <img v-if="profilePhotoComputed != null" :src="profilePhotoComputed" alt="">
                </div>
            </div>
            <div class="text-white text-lg px-4 flex-auto  self-center uppercase min-w-0">
                <div class="text-lg line-clamp-1 break-all">{{ profile.firstName }}</div>
                <div class="text-lg line-clamp-1 break-all">
                    {{ profile.lastName }}
                </div>
            </div>
            <div class="flex-none pt-4">
                <button
                    class="outline-none border border-white bg-transparent text-white py-2px px-3 rounded-3xl text-sm"
                    @click="goEdit()"
                >{{ lbl.default.edit }}</button>
            </div>
        </div>
        <div class="mt-4 grid grid-cols-1 gap-2 text-white text-sm">
            <div class="flex">
                <div class="flex-none w-32 uppercase">{{ lbl.profile.dateOfBirth }} :</div>
                <div class="flex-auto pl-3">{{ formatDate(profile.birthDate) }}</div>
            </div>
            <div class="flex">
                <div class="flex-none w-32 uppercase">{{ lbl.profile.gender.name }} :</div>
                <div class="flex-auto pl-3">{{ genderComputed }}</div>
            </div>
            <div class="flex">
                <div class="flex-none w-32 uppercase">{{ lbl.profile.phoneNumber.default }} :</div>
                <div class="flex-auto pl-3">+{{ contactNumberFormat }}</div>
            </div>
            <div class="flex">
                <div class="flex-none w-32 uppercase">{{ lbl.profile.emailLabel }} :</div>
                <div class="flex-auto pl-3">{{ profile.email == "" ? "-" : profile.email }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import DatetimeHelper from "@/helper/DatetimeHelper"
import LocaleMixin from "@/mixin/LocaleMixin"
import Utility from '@/helper/Utility'

export default {
    name: 'ProfileHeader',
    props: {},
    components: {},
    mixins: [LocaleMixin],
    emits: [],
    inject: ["profileObj", "profilePhoto"],
    data: function () { return {} },
    computed: {
        profile: function () {
            return this.profileObj.value || {}
        },
        genderComputed: function () {
            if (this.profile.gender == null || this.profile.gender == "notspecified") {
                return "-"
            }
            return this.lbl.profile[this.profile.gender] || "-"
        },
        profilePhotoComputed: function(){
            let photo = this.profilePhoto.value
            return photo
        },
        contactNumberFormat:function() {
            var tel = this.profile.contactNumber || ''
            // tel = tel.substring(0, 7) + 'xxxx';
            tel = tel.slice(0,-4) + 'xxxx'
            return tel
        }
    },
    created: function () { },
    mounted: function () { },
    methods: {
        formatDate: function (val) {
            if (Utility.isEmptyStr(val)) {
                return "-"
            } else {
                return DatetimeHelper.dateFullFormat(DatetimeHelper.unixTimestampToDate(val))
            }
        },
        goEdit: function () {
            this.tracking.event('edit_profile', 'click_edit_profile', null, null);
            this.$router.push({
                name: "edit-profile"
            })
        }
    }
}
</script>
